import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { cn } from '@/lib/utils';

interface CollapsibleDrawerProps {
  title?: string;
  defaultOpen?: boolean;
  isScheduled?: boolean;
  children: React.ReactNode;
}

const CollapsibleDrawer: React.FC<CollapsibleDrawerProps> = ({
  title = 'Upload Settings',
  defaultOpen = false,
  isScheduled = false,
  children,
}) => {
  return (
    <Accordion type="single" collapsible defaultValue={defaultOpen ? title : undefined} className="w-full">
      <AccordionItem value={title} className="border-none">
        <AccordionTrigger 
          className={cn(
            "text-base font-semibold hover:no-underline py-3 px-4 border rounded-md transition-colors cursor-pointer mb-2",
            isScheduled 
              ? "border-secondary/50 hover:border-secondary hover:bg-secondary/10" 
              : "border-primary/50 hover:border-primary hover:bg-primary/10"
          )}
        >
          {title}
        </AccordionTrigger>
        <AccordionContent className="pt-0 pb-0 pl-4">
          {children}
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};

export default CollapsibleDrawer;
